import React from 'react'

import { RevisionHistoryRenewal } from './revision-history-renewal'
import { useRevisionHistory } from './revision-history.hooks'
import { useDocuSignPreview } from '../../use-docusign-preview'

export const RevisionHistoryContainer: React.FC = () => {
  const {
    icfDocument,
    selectedRevision,
    selectedRevisionUid,
    onChangeSelectedRevisionUid,
    filePreviewUrl,
  } = useRevisionHistory()

  const { redirect: redirectDocuSignPreview } = useDocuSignPreview()

  return (
    <RevisionHistoryRenewal
      icfDocument={icfDocument}
      selectedRevisionUid={selectedRevisionUid}
      selectedRevision={selectedRevision}
      onChangeSelectedRevisionUid={onChangeSelectedRevisionUid}
      filePreviewUrl={filePreviewUrl}
      onRedirectDocuSignPreview={redirectDocuSignPreview}
    />
  )
}
